module.exports = __webpack_public_path__ + "img/header-2.a44a7c06.png";